import React, { useCallback, useMemo } from 'react';
import moment from 'moment-timezone';
import styled from 'styled-components';
import { getCurrentStateOfLocationSlots, getSelectedSlot } from '../../util';
import { WIDGET_BOOKING_TIME_SELECTOR_MODAL } from '../../SlotSelector/components/TimeSelectorModal';
import NoSlotsToday from './components/NoSlotsToday';
import SlotsTodayOrTomorrow from './components/SlotsTodayOrTomorrow';
import NoSlotsTomorrow from './components/NoSlotsTomorrow';

const Content = styled.div.withConfig({ componentId: 'sc-ewbyak-0' })`
  padding: 20px 0;
  width: 100%;
`;

type OwnProps = {
  location: any;
  modalState?: any;
  futureSlotData: any;
  handleSelectSlot: (...args: any[]) => any;
  nextDate: any;
  selectedSlots: any[];
  showModal: (modalId: string) => void;
  setHasOpenedTimeSelectorModal?: (...args: any[]) => any;
  setAndHandleDate?: (...args: any[]) => any;
  shouldShowWalkInCopy?: boolean;
  // Below props are for old booking flow
  shouldSelectFirstSlotAsInitialValue: boolean;
  shouldSetSelectedSlotToFirstVisibleSlot: boolean;
};

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
type Props = OwnProps & typeof StackedView.defaultProps;

// @ts-expect-error ts-migrate(7022) FIXME: 'StackedView' implicitly has type 'any' because it... Remove this comment to see the full error message
const StackedView = (props: Props) => {
  const {
    location,
    futureSlotData,
    handleSelectSlot,
    nextDate,
    selectedSlots,
    showModal,
    shouldShowWalkInCopy,
    setAndHandleDate,
    // Below props are for old booking flow
    shouldSelectFirstSlotAsInitialValue,
    shouldSetSelectedSlotToFirstVisibleSlot,
  } = props;

  const today = moment.tz(location.timeZone);
  const tomorrow = moment(today).add(1, 'day');

  const hasSlotsAvailableOnDay = useCallback(
    (day) => {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isClinicClosed' does not exist on type '... Remove this comment to see the full error message
      const { isClinicClosed, selectedDateHasNoSlotsLeft } = getCurrentStateOfLocationSlots(
        futureSlotData,
        location,
        day
      );

      const selectedDateHasSlotsLeft = !selectedDateHasNoSlotsLeft;

      return !isClinicClosed && selectedDateHasSlotsLeft;
    },
    [futureSlotData, location]
  );

  const hasSlotsAvailableToday = useMemo(() => {
    return hasSlotsAvailableOnDay(today);
  }, [hasSlotsAvailableOnDay, today]);

  const hasSlotsAvailableTomorrow = useMemo(() => {
    return hasSlotsAvailableOnDay(tomorrow);
  }, [hasSlotsAvailableOnDay, tomorrow]);

  const handleClickShowMore = () => showModal(WIDGET_BOOKING_TIME_SELECTOR_MODAL);

  const selectedDate = getSelectedSlot({ selectedSlots, location });

  const hasSlotsAvailableTodayOrTomorrow = hasSlotsAvailableToday || hasSlotsAvailableTomorrow;
  const shouldShowNoSlotsForTodaySection = !hasSlotsAvailableToday && !selectedDate;
  const shouldShowNoSlotsForTomorrowSection =
    !hasSlotsAvailableTomorrow && !selectedDate && !hasSlotsAvailableTodayOrTomorrow;

  return (
    <Content>
      <NoSlotsToday
        futureSlotData={futureSlotData}
        handleClickShowMore={handleClickShowMore}
        handleSelectSlot={handleSelectSlot}
        isVisible={shouldShowNoSlotsForTodaySection}
        location={location}
        nextDate={nextDate}
        selectedDate={today}
        selectedSlots={selectedSlots}
        setAndHandleDate={setAndHandleDate}
        shouldSelectFirstSlotAsInitialValue={shouldSelectFirstSlotAsInitialValue}
        shouldSetSelectedSlotToFirstVisibleSlot={shouldSetSelectedSlotToFirstVisibleSlot}
        shouldShowWalkInCopy={shouldShowWalkInCopy}
      />

      <SlotsTodayOrTomorrow
        futureSlotData={futureSlotData}
        handleClickShowMore={handleClickShowMore}
        handleSelectSlot={handleSelectSlot}
        isVisible={hasSlotsAvailableTodayOrTomorrow || selectedDate}
        location={location}
        nextDate={nextDate}
        selectedDate={selectedDate}
        selectedSlots={selectedSlots}
        setAndHandleDate={setAndHandleDate}
        shouldSelectFirstSlotAsInitialValue={shouldSelectFirstSlotAsInitialValue}
        shouldSetSelectedSlotToFirstVisibleSlot={shouldSetSelectedSlotToFirstVisibleSlot}
        shouldShowWalkInCopy={shouldShowWalkInCopy}
      />

      <NoSlotsTomorrow
        futureSlotData={futureSlotData}
        handleClickShowMore={handleClickShowMore}
        handleSelectSlot={handleSelectSlot}
        isVisible={shouldShowNoSlotsForTomorrowSection}
        location={location}
        nextDate={nextDate}
        selectedDate={tomorrow}
        selectedSlots={selectedSlots}
        setAndHandleDate={setAndHandleDate}
        shouldSelectFirstSlotAsInitialValue={shouldSelectFirstSlotAsInitialValue}
        shouldSetSelectedSlotToFirstVisibleSlot={shouldSetSelectedSlotToFirstVisibleSlot}
        shouldShowWalkInCopy={shouldShowWalkInCopy}
      />
    </Content>
  );
};

export default StackedView;
